import type { BrandAssets } from '@/shared/config/brand';
import { BRAND } from '@/shared/config/brand';

const FAVICON_ID = 'app-favicon';
/** Incrementar ao trocar os assets para forçar atualização em cache do navegador. */
const FAVICON_VERSION = '3';

function faviconHref(resolved: 'light' | 'dark', assets: BrandAssets): string {
  const file = resolved === 'dark' ? assets.favicon.dark : assets.favicon.brand;
  return `${file}?v=${FAVICON_VERSION}`;
}

/** Garante um único favicon ativo (remove links antigos que mantinham o ícone legado). */
export function syncFavicon(resolved: 'light' | 'dark', assets: BrandAssets = BRAND) {
  const href = faviconHref(resolved, assets);

  document.querySelectorAll('link[rel="icon"]').forEach((node) => {
    if (node.id !== FAVICON_ID) node.remove();
  });

  let link = document.getElementById(FAVICON_ID) as HTMLLinkElement | null;
  if (!link) {
    link = document.createElement('link');
    link.id = FAVICON_ID;
    link.rel = 'icon';
    link.type = 'image/png';
    document.head.appendChild(link);
  }

  if (!link.href.includes(href)) {
    link.href = href;
  }
}

export function resolveThemeForFavicon(): 'light' | 'dark' {
  const stored = localStorage.getItem('fixe-theme');
  if (stored === 'dark') return 'dark';
  if (stored === 'light') return 'light';
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}
